/**
 * Public, unauthenticated links this app hands to a patient — the status
 * page they can open without logging in to watch their queue position or
 * appointment. See backend/routes/queue-status.js and
 * src/components/QueueStatusPage.jsx, which reads this same `?queue_status=`
 * param (dispatched in main.tsx).
 *
 * Lives here rather than inside features/queue because it is not
 * queue-specific: a booking confirmation in Appointments hands out the exact
 * same link (a booked slot's status_token resolves through the same public
 * page), and Registration's merge/duplicate flow will too. Promoted out once
 * a second real feature needed it, not preemptively.
 */
export function queueStatusUrl(token: string): string {
  return `${window.location.origin}/?queue_status=${token}`;
}
